import { UUID_regex } from "Utils/General/KeyGenerator";
import { AddSchema } from "mobx-firelink";
export class Character {
    constructor(initialData) {
        this.Extend(initialData);
    }
}
AddSchema("Character", {
    properties: {
        book: { $ref: "UUID" },
        name: { type: "string" },
        note: { type: "string" },
        description: { type: "string" },
        level: { type: "number" },
        attributeLevels: { $ref: "AttributeLevels" },
        eventIndexes: { $ref: "EventIndexSet" },
    },
});
AddSchema("AttributeLevels", { patternProperties: { [UUID_regex]: { type: "number" } } });
AddSchema("EventIndexSet", { patternProperties: { "^[0-9]+$": { $ref: "UUID" } } });
